<template lang="html">
  <div
    class="weather-background"
    :class="css"
    :style="style">
    <slot />
  </div>
</template>

<script>
import moment from 'moment'
import tinygradient from 'tinygradient'
export default {
  name: 'WeatherForecastBackground',
  props: {
    code: {
      type: String,
      default: '800'
    },
    colorLight: {
      type: String,
      default: '#00BFFF'
    },
    colorDark: {
      type: String,
      default: '#0C1A23'
    },
    time: {
      type: Number
    }
  },
  computed: {
    css () {
      return 'code-' + this.code
    },
    palette () {
      const gradient = tinygradient([
        { color: this.colorDark, pos: 0 },
        { color: this.colorLight, pos: 0.5 },
        { color: this.colorDark, pos: 1 }
      ])
      return gradient.rgb(24).map(tc => {
        return tc.toHexString()
      })
    },
    style () {
      const time = this.time ? moment.unix(this.time) : moment()
      const hour = time.format('k')
      const backgroundColor = this.palette[Number(hour) - 1]
      return { backgroundColor }
    }
  }
}
</script>

<style lang="scss">
.weather-background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-size: contain;
  background-position: center top;
  background-repeat: no-repeat;
  transition: all .5s ease-in-out;
  &.code-80D { background-image: url('./images/80D.png') }
  &.code-80N { background-image: url('./images/80N.png') }
  &.code-800 { background-image: url('./images/800.png') }
  &.code-200 { background-image: url('./images/200.png') }
  &.code-500 { background-image: url('./images/500.png') }
  &.code-600 { background-image: url('./images/600.png') }
  &.code-700 { background-image: url('./images/700.png') }
}
</style>
